import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, MessageKnowledgeBaseItemsResponseData } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof MessageKnowledgeBaseItemsResponseData>>

export const conversationMessageKnowledgeBaseItemsQuery = (id: string) => {
  return queryOptions({
    queryKey: ["conversations", "messageKnowledgeBaseItems", id],
    queryFn: async () => {
      const response = await axios.get<Response>(`/messages/${id}/knowledgeBaseItems`)
      return response.data.data.sort((a, b) => (a.score > b.score ? -1 : 1))
    },
  })
}
